import React, { useState } from "react";
import { Link } from "react-router-dom";
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from "firebase/auth";
import { auth } from "../firebase";
import Window from "./Window";

// Change your password while signed in (asks for the current one first).
export default function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [state, setState] = useState<"form" | "saving" | "done">("form");
  const [error, setError] = useState("");

  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    const user = auth.currentUser;
    if (!user?.email) return;
    setError("");
    if (next.length < 8) {
      setError("Please use at least 8 characters.");
      return;
    }
    if (next !== confirm) {
      setError("The new passwords don't match.");
      return;
    }
    setState("saving");
    try {
      await reauthenticateWithCredential(user, EmailAuthProvider.credential(user.email, current));
      await updatePassword(user, next);
      setCurrent("");
      setNext("");
      setConfirm("");
      setState("done");
    } catch (err: any) {
      const code = err?.code || "";
      setError(
        code === "auth/wrong-password" || code === "auth/invalid-credential"
          ? "Your current password isn't right."
          : code === "auth/weak-password"
          ? "That new password is too easy to guess. Try a longer one."
          : code === "auth/too-many-requests"
          ? "Too many tries. Please wait a little and try again."
          : "Sorry, that didn't work. Please try again."
      );
      setState("form");
    }
  };

  return (
    <Window title="password.ini" tone="blue">
      {state === "done" ? (
        <div className="flex flex-wrap items-center gap-3">
          <p className="success-text">Your password has been changed ✿</p>
          <button type="button" className="btn btn-plain btn-sm" onClick={() => setState("form")}>
            Change it again
          </button>
        </div>
      ) : (
        <form onSubmit={save} className="flex flex-col gap-3">
          <div className="grid gap-3 sm:grid-cols-3">
            <label className="field">
              <span className="field-label">Current password</span>
              <input
                type="password"
                className="input"
                value={current}
                onChange={(e) => setCurrent(e.target.value)}
                autoComplete="current-password"
                required
              />
            </label>
            <label className="field">
              <span className="field-label">New password</span>
              <input
                type="password"
                className="input"
                value={next}
                onChange={(e) => setNext(e.target.value)}
                autoComplete="new-password"
                minLength={8}
                required
              />
            </label>
            <label className="field">
              <span className="field-label">New password again</span>
              <input
                type="password"
                className="input"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                autoComplete="new-password"
                required
              />
            </label>
          </div>
          {error && <p className="error-text">{error}</p>}
          <div className="flex flex-wrap items-center gap-3">
            <button type="submit" className="btn btn-sm" disabled={state === "saving"}>
              {state === "saving" ? "Saving..." : "Change password"}
            </button>
            <Link to="/forgot-password" className="text-sm">
              Don't remember your current one?
            </Link>
          </div>
        </form>
      )}
    </Window>
  );
}
